import axios from 'axios';

export const send = payload => axios.post('/api/audit_log', {
  ...payload,
  query: typeof payload.query === 'string' ? payload.query : JSON.stringify(payload.query),
});
